<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">אישור תנאי שימוש ומדיניות פרטיות</p>
    </header>
    <section class="modal-card-body">
      <div v-if="isVersionUpdate" class="update-notice">
        <p class="update-notice__title">יש לנו מדיניות פרטיות מעודכנת</p>
        <p>חשוב לנו לעדכן אותך שמדיניות הפרטיות שלנו התעדכנה. יש לקרוא ולאשר את התנאים, בכדי להמשיך את השימוש במערכת.</p>
      </div>
      <b-field>
        <b-checkbox v-model="termsAccepted">
          קראתי ואני מסכים ל<a href="/terms.html" target="_blank">תנאי השימוש</a>
        </b-checkbox>
      </b-field>
      <b-field>
        <b-checkbox v-model="privacyAccepted">
          קראתי ואני מסכים ל<a href="/privacy.html" target="_blank">מדיניות הפרטיות</a>
        </b-checkbox>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <b-button
        type="is-primary"
        :disabled="!termsAccepted || !privacyAccepted"
        :loading="isLoading"
        @click="confirm"
      >
        אישור והמשך
      </b-button>
    </footer>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService';

export default {
  name: 'DialogLegalAcceptance',
  props: {
    termsVersion: { type: String, required: true },
    privacyVersion: { type: String, required: true },
    isVersionUpdate: { type: Boolean, default: false },
  },
  data() {
    return {
      termsAccepted: false,
      privacyAccepted: false,
      isLoading: false,
    };
  },
  methods: {
    async confirm() {
      this.isLoading = true;
      try {
        await AuthService.acceptLegal(this.termsVersion, this.privacyVersion);
        this.$emit('accepted');
        this.$emit('close');
      } catch (e) {
        console.error('acceptLegal error', e);
        this.$buefy.toast.open({ type: 'is-danger', message: 'אירעה שגיאה, נסה שנית' });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.update-notice {
  background-color: #fff0ec;
  border-radius: 6px;
  padding: 14px 18px;
  margin-bottom: 20px;
  color: #ff7a59;
  text-align: center;
}

.update-notice__title {
  font-weight: 600;
  margin-bottom: 6px;
}

.b-checkbox.checkbox::v-deep .control-label {
  padding-left: 0.75em;
  padding-right: 8px;
}
</style>
